import { BUS_EVENTS } from './externalEventBus';

let appOptionsLocal = {};

function dispatchEvent(detail) {
  if (appOptionsLocal.loggerLevel === 'info')
    console.info('[affiliateListener]', { detail }); // eslint-disable-line no-console

  const event = new CustomEvent('fritsEvent', { detail });
  global.dispatchEvent(event);
}

export function initAffiliateListener({ $bus, appOptions }) {
  appOptionsLocal = appOptions;

  BUS_EVENTS.forEach(event => $bus[event].listen(dispatchEvent));
}
